import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { reportService } from '../services/audiometryService';
import './ReportEditor.css';

function ReportEditor() {
  const { examId } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editedContent, setEditedContent] = useState('');

  useEffect(() => {
    loadReport();
  }, [examId]);

  const loadReport = async () => {
    try {
      setLoading(true);
      const data = await reportService.getByExamId(examId);
      setReport(data);
      if (data && data.draftJson) {
        const draft = JSON.parse(data.draftJson);
        setEditedContent(draft.summary_text || '');
      }
    } catch (error) {
      console.error('Erro ao carregar laudo:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateDraft = async () => {
    try {
      setGenerating(true);
      const data = await reportService.generateDraft(examId);
      setReport(data);
      if (data && data.draftJson) {
        const draft = JSON.parse(data.draftJson);
        setEditedContent(draft.summary_text || '');
      }
    } catch (error) {
      console.error('Erro ao gerar rascunho:', error);
    } finally {
      setGenerating(false);
    }
  };

  const handleSave = async () => {
    try {
      const updatedDraft = {
        ...JSON.parse(report.draftJson),
        summary_text: editedContent,
      };
      
      await reportService.update(report.id, {
        draftJson: JSON.stringify(updatedDraft),
      });
      
      setEditing(false);
      toast.success('Laudo salvo com sucesso!', {
        icon: '💾',
        duration: 3000,
      });
    } catch (error) {
      console.error('Erro ao salvar laudo:', error);
      toast.error('Erro ao salvar laudo', {
        duration: 5000,
      });
    }
  };

  if (loading) {
    return <div className="loading">Carregando laudo...</div>;
  }

  const draftData = report && report.draftJson ? JSON.parse(report.draftJson) : null;

  return (
    <div className="report-editor-container">
      <div className="editor-header">
        <h1>Editor de Laudo</h1>
        {!report && (
          <button
            className="btn-primary"
            onClick={handleGenerateDraft}
            disabled={generating}
          >
            {generating ? 'Gerando...' : 'Gerar Rascunho com IA'}
          </button>
        )}
      </div>

      {!report && !generating && (
        <div className="empty-state">
          <p>Nenhum laudo encontrado para este exame.</p>
          <p>Clique em "Gerar Rascunho com IA" para criar um novo laudo.</p>
        </div>
      )}

      {draftData && (
        <div className="editor-layout">
          <div className="editor-main">
            <div className="editor-toolbar">
              {!editing ? (
                <button className="btn-secondary" onClick={() => setEditing(true)}>
                  Editar
                </button>
              ) : (
                <>
                  <button className="btn-primary" onClick={handleSave}>
                    Salvar
                  </button>
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setEditing(false);
                      setEditedContent(draftData.summary_text);
                    }}
                  >
                    Cancelar
                  </button>
                </>
              )}
            </div>

            <div className="editor-content">
              {editing ? (
                <textarea
                  className="editor-textarea"
                  value={editedContent}
                  onChange={(e) => setEditedContent(e.target.value)}
                />
              ) : (
                <div className="editor-preview">
                  <p>{editedContent}</p>
                </div>
              )}
            </div>
          </div>

          <div className="editor-sidebar">
            <div className="sidebar-section">
              <h3>Justificativas T�cnicas</h3>
              <ul>
                {draftData.technical_justification?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="sidebar-section">
              <h3>Recomenda��es</h3>
              <ul>
                {draftData.recommendations?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="sidebar-section">
              <h3>N�vel de Confian�a</h3>
              <div className="confidence-score">
                <div className="confidence-bar">
                  <div
                    className="confidence-fill"
                    style={{
                      width: `${(draftData.confidence_score || 0) * 100}%`,
                    }}
                  />
                </div>
                <span>{((draftData.confidence_score || 0) * 100).toFixed(0)}%</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReportEditor;
